import { AppBar, Toolbar } from "@mui/material";

// component
import MenuButton from "./MenuButton";
import BasketCount from "./BasketCount/BasketCount";

//assets
import { Icons } from "assets/Icons";

const TopMenu: React.FC = (): React.ReactElement => {
  return (
    <AppBar position="static" sx={{background: "transparent", boxShadow: "none", marginTop: "17px"}}>
      <Toolbar
        variant="dense"
        sx={{
          justifyContent: "space-between",
          flexWrap: "nowrap",
          width: "156px",
          padding: "8px 10px !important",
          minHeight: 40,
        }}
      >
        <MenuButton icon={Icons.home1} active/>
        <MenuButton icon={Icons.media} viewBox="0 0 26 26" path="/media" padding="2px"/>
        <MenuButton icon={Icons.basket} viewBox="0 0 30 24" path="/basket">
          <BasketCount />
        </MenuButton>
      </Toolbar>
    </AppBar> 
  )
};

export default TopMenu;